export default __webpack_public_path__ + "8ec34bd593bbc3bec41b2c1f6ce7ac33.png";